const EmbeddingType = {
  Dashboard: 'Dashboard',
  Library: 'Library',
  Visualization: 'Visualization',
  Bot: 'Agent',
  Bot_Api: 'Bot_Api',
  Bot_Auto: 'Bot_Auto',
  Bot_AutoImage: 'Bot_AutoImage',
  NextGet_AI: 'NextGet_AI',
  NextGet_AI_WithViz: 'NextGet_AI_WithViz',

  getFilterTapType(embeddingType) {
    const mapping = {
      [EmbeddingType.Bot_Api]: EmbeddingType.Bot,
      [EmbeddingType.Bot_Auto]: EmbeddingType.Bot,
      [EmbeddingType.Bot_AutoImage]: EmbeddingType.Bot,
      [EmbeddingType.NextGet_AI]: EmbeddingType.Bot,
      [EmbeddingType.NextGet_AI_WithViz]: EmbeddingType.Bot,
    };
    return mapping[embeddingType] || embeddingType;
  },
};

export default EmbeddingType;
